import { FC, useContext, useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";

import {
  // DownloadZipErrorType,
  DownloadZipResponseType
} from "src/pages/dashboard/types";
import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { LoaderContext } from "src/context/loaderContext";
// import { ToastContext } from "src/context/toastContext";

import { CaseInformationProps, DownloadBenefitPDFResponseTypeApi } from "./types";
// import { AuthContext } from "src/context/authContext";
// import { ToastTypes } from "src/types";
import { downloadPdfFile } from "src/helpers/downloadFile";
import { format, parse } from "date-fns";
import { AuthContext } from "src/context/authContext";
import { detectDateFormat } from "src/helpers/case";



const CaseInformation: FC<CaseInformationProps> = ({ caseObject }): JSX.Element => {
  // const navigate = useNavigate();
  const { setLoader, hideLoader } = useContext(LoaderContext);
  // const { showToast } = useContext(ToastContext);
   const { isManufacturer } = useContext(AuthContext);
  const [enabledButton, setEnabledButton] = useState<boolean>(false);

  const formatInjectionSite = (site: string): string => {
    if (!site) return "";

    const lower = site.trim().toLowerCase();

    // Case 1: only knee
    if (lower === "knee") {
      return "Knee";
    }

    // Case 2: left, right, bilateral → add "Knee"
    if (["left", "right", "bilateral"].includes(lower)) {
      return lower.charAt(0).toUpperCase() + lower.slice(1) + " Knee";
    }

    // Case 3: other values (shoulder, other, etc.)
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  }



  const {
    loading: downloadRequestFormLoader,
    data: downloadCaseData, error: downloadCaseError, mutate: downloadRequestForm, removeErrorAndData: clearRequestFileData
  } = useFetch<DownloadZipResponseType>(APIEndpoints.DOWNLOAD_REQUEST_FORM);

  useEffect(() => {
    if (downloadCaseData || downloadCaseError) {
      if (downloadCaseData) {
        const { response } = downloadCaseData;
        downloadPdfFile(response, `case_${caseObject.case_information.case_id}_reports.pdf`);
      }
      hideLoader();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadCaseData, downloadCaseError]);

  const downloadFileByCaseId = () => {
    // OpenForm Enrollment
    if (downloadCaseData || downloadCaseError) clearRequestFileData();
    setLoader();

    if (caseObject && caseObject.case_information) {
      // console.log({}, {}, { ref_id: caseObject.case_information.case_id, type: `${caseObject.case_information.product.toLowerCase()}-request`, ref_type: 'Case' });
  downloadRequestForm({}, {},isManufacturer ? { ref_id: caseObject.case_information.case_id, type: `${caseObject.case_information.product.toLowerCase().replace("°", "")}-request`, ref_type: 'Case',skip_pi:true } : { ref_id: caseObject.case_information.case_id, type: `${caseObject.case_information.product.toLowerCase().replace("°", "")}-request`, ref_type: 'Case'  }) }
  };

  const generateCPTCode = (cpts: [[string], string]): string => {
    if (cpts && cpts[1].length > 0) {
      if (cpts[1].includes("Both") && cpts[1].includes("-")) {
        const firstCPTString = cpts[1].split("-")[0].trim();
        const cptCodes = firstCPTString.replace("Both", "").replace("&", "").trim().split(/\s+/)
        return cptCodes.join(", ")
      } else {
        return cpts[0][0];
      }
    }
    return "N/A"
  }





  //////////////////////////////////////////////////Download PDF Benefits////////////////////////////////////////////
  const {
    data: downloadBenefitCaseData, error: downloadBenefitCaseError,
    removeErrorAndData: clearBenefitRequestFileData, mutate: downloadBenefitRequestForm,
  } = useFetch<DownloadBenefitPDFResponseTypeApi>(APIEndpoints.DOWNLOAD_REQUEST_FORM);

  useEffect(() => {
    if (downloadBenefitCaseData || downloadBenefitCaseError) {
      if (downloadBenefitCaseData) {
        const { response, report_name } = downloadBenefitCaseData;
        downloadPdfFile(response, `${report_name}`);
      }
      hideLoader();
      setEnabledButton(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadBenefitCaseData, downloadBenefitCaseError]);

  const downloadBenefitClickOnPdf = (refId: number, benefitType: string) => {
    if (downloadBenefitCaseData || downloadBenefitCaseError) clearBenefitRequestFileData();
    setLoader();
    setEnabledButton(true);
    downloadBenefitRequestForm({}, {}, isManufacturer ? 
      { ref_id: refId, type: `${caseObject.case_information.product.toLowerCase().replace("°", "")}-investigation`, ref_type: 'Insurance', benefit_type: benefitType,skip_pi_investigation:true } : 
      { ref_id: refId, type: `${caseObject.case_information.product.toLowerCase().replace("°", "")}-investigation`, ref_type: 'Insurance', benefit_type: benefitType });
  };





  return (
    <div className="card">
      <div className={`card-header ${caseObject.case_information.product === 'iovera°' ? 'iovera-theme' : 'zilretta-theme'}`}>
        <h4 className="m-0">Case Information</h4>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 px-3">
                <label className="form-label">Submitted by:</label>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information ? caseObject.case_information.submitted : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6"></div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 px-3">
                <label className="form-label">Created:</label>
              </div>
              <div className="col-6">
                <p>{caseObject && caseObject.case_information ? caseObject.case_information.created : "N/A"}</p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 px-3">
                <label className="form-label">Product:</label>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information ? caseObject.case_information.product : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 px-3">
                <label className="form-label">Shipment Date:</label>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information ? caseObject.case_information.shipment_date : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 px-3">
                <label className="form-label">Treatment Area:</label>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information ? caseObject.case_information.injection_site === "other" ? caseObject.case_information.note : formatInjectionSite(caseObject.case_information.injection_site) : "N/A"}
                </p>
              </div>
            </div>
          </div>

          {/* <div className="col-6"></div> */}


          <div className="col-12 col-md-6">
            {caseObject.case_information.product.includes("iovera") ?
              (<div className="row">
                <div className="col-6">
                  <label className="form-label">Benefits Type:</label>
                </div>
                <div className="col-6">
                  <p>
                    Medical
                  </p>
                </div>
              </div>)
              :
              (<div className="row">
                <div className="col-6">
                  <label className="form-label">Benefits Type:</label>
                </div>
                <div className="col-6">
                  <p>
                    {caseObject && caseObject.case_information ? caseObject.case_information.benefits_type : "N/A"}
                  </p>
                </div>
              </div>)
            }
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 px-3">
                <label className="form-label">CPT Code:</label>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information ? 
                    generateCPTCode(caseObject.case_information.cpt_information)
                    : "N/A"
                  }
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">{caseObject && caseObject.case_information && caseObject.case_information.product.toLowerCase() === "zilretta" ? "Last Injection Date:" : "Last Surgical Date:"}</label>
              </div>
              <div className="col-6">
                <p>
                  {
                    caseObject && caseObject.case_information && caseObject.case_information.product.toLowerCase() === "zilretta" ?
                      caseObject.case_information.last_date_of_service ?
                        format(parse(caseObject.case_information.last_date_of_service, "yyyy-MM-dd", new Date()), "MM/dd/yyyy")
                        : "N/A"
                      : caseObject.case_information.last_surgical_date ?
                        format(parse(caseObject.case_information.last_surgical_date, "yyyy-MM-dd", new Date()), "MM/dd/yyyy")
                        : "N/A"
                  }
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 px-3">
                <label className="form-label">Treatment Date:</label>
              </div>
              <div className="col-6">
                <p>
                  {caseObject.case_information.product === "ZILRETTA" ?
                    caseObject && caseObject.case_information && caseObject.case_information.scheduled_date_of_service ?
                      format(parse(caseObject.case_information.scheduled_date_of_service, "yyyy-MM-dd", new Date()), "MM/dd/yyyy")
                      : "N/A"
                    :
                    caseObject && caseObject.case_information && caseObject.case_information.treatment_date ?
                      format(parse(caseObject.case_information.treatment_date, "yyyy-MM-dd", new Date()), "MM/dd/yyyy")
                      : "N/A"
                  }
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            {caseObject.case_information.product.toLowerCase().includes("zil") ? (
              <div className="row">
                <div className="col-6 text-end px-3">
                  <label className="form-label">Quantity:</label>
                </div>
                <div className="col-6">
                  <p>
                    {caseObject && caseObject.case_information ? caseObject.case_information.quantity : "N/A"}
                  </p>
                </div>
              </div>
            ) : (
              <div className="row">
                <div className="col-6 text-end px-3">
                  <label className="form-label">Nerve Quantity:</label>
                </div>
                <div className="col-6">
                  <p>
                    {caseObject && caseObject.case_information && caseObject.case_information.nerves_qty ? 
                      Number(caseObject.case_information.nerves_qty).toFixed(1)
                      : "N/A"}
                  </p>
                </div>
              </div>
            )}
            {/* <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">
                  {caseObject.case_information.product.toLowerCase().includes("zil") ? 'Quantity' : 'Nerve Quantity'}:
                </label>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information ? caseObject.case_information.quantity : "N/A"}
                </p>
              </div>
            </div> */}
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Diagnosis Code:</label>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information ? caseObject.case_information.diagnosis_code.split(",").join(", ") : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Note:</label>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information ? caseObject.case_information.injection_site === "other" ? "N/A" : caseObject.case_information.note : "N/A"}
                </p>
              </div>
            </div>
          </div>

          {/* <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Directions:</p>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information ? caseObject.case_information.product === "zilretta" ? caseObject.case_information.directions : "N/A" : "N/A"}
                </p>
              </div>
            </div>
          </div> */}
          {caseObject.case_information.product === 'iovera°' ? (
            <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-6 text-end px-3">
                  <label className="form-label">Surgical Date:</label>
                </div>
                <div className="col-6">
                  <p>{caseObject && caseObject.case_information && caseObject.case_information.surgical_date ? 
                    detectDateFormat(caseObject.case_information.surgical_date) ?
                      format(parse(caseObject.case_information.surgical_date, detectDateFormat(caseObject.case_information.surgical_date) || "", new Date()), "MM/dd/yyyy") :
                      "N/A"  
                  : "N/A"}</p>
                </div>
              </div>
            </div>
          ) : (
            <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-6 text-end px-3">
                  <label className="form-label">Directions:</label>
                </div>
                <div className="col-6">
                  <p>{caseObject && caseObject.case_information && caseObject.case_information.directions ? 
                    caseObject.case_information.directions
                  : "N/A"}</p>
                </div>
              </div>
            </div>
          )}


          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Written Date:</label>
              </div>
              <div className="col-6">
                <p>{caseObject && caseObject.case_information ? caseObject.case_information.written_date : "N/A"}</p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
          </div>

          {!caseObject.case_information.product.includes('iovera') && <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Auto X-fer to Pharmacy:</label>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information ? caseObject.case_information.auto_xfer : "N/A"}
                </p>
              </div>
            </div>
          </div>}
            <div className="col-12 col-md-6"></div>
            <div className="col-12 col-md-6">
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <label className="form-label">Request Form:</label>
                    </div>
                    <div className="col-6">
                        <p className="d-flex gap-1">
                            <i className="bi bi-file-pdf text-danger"></i>
                            <button
                                onClick={downloadFileByCaseId}
                                disabled={downloadRequestFormLoader}
                                type="button"
                                className="btn btn-link link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover p-0 align-baseline"
                            >
                                Download
                            </button>
                        </p>
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <label className="form-label">Benefits Investigations:</label>
                    </div>
                    <div className="col-6">
                        {
                            caseObject && caseObject.case_information && typeof caseObject.case_information.benefit_investigation !== 'string' ?
                                caseObject.case_information.benefit_investigation.map((benefit) => (
                                    benefit.completed_benefits.map((item, index) => (
                                        <p key={index} className="d-flex gap-1">
                                            <i className="bi bi-file-pdf"></i>
                                            <button
                                                className="btn btn-link link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover p-0 align-baseline text-start"
                                                onClick={() => downloadBenefitClickOnPdf(benefit.id, item.benefit_type)}
                                                disabled={enabledButton}>
                                                {item.download_title}

                                            </button>
                                        </p>
                                    ))
                                ))
                                : 'N/A'
                        }
                    </div>
                </div>
            </div>
          {((caseObject.case_information.product === 'zilretta') || (caseObject.case_information.product  === "ZILRETTA")) &&
            <div className="row">
              <div className="col-6 col-md-4 text-end py-3">
                <label className="form-label justify-content-start">Has the patient been treated with ZILRETTA in the past:</label>
              </div>
              <div className="col-6 col-md-8 py-3">
                <p className={"mb-0"}>{caseObject && caseObject.case_information ? caseObject.case_information.has_been_treated : 'N/A'}</p>
              </div>
            </div>
          }


        </div>
      </div>
    </div>
  );
};

export default CaseInformation;
